import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import InputText from '../../elements/InputText';
// import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ContactListModal from '../../modals/ContactListModal';
import AddressBookModal from '../../modals/AddressBookModal';
import ProductFinderModal from '../../modals/ProductFinderModal';
import PaymentsListModal from '../../modals/PaymentsListModal';
import initTreeView from '../../../services/initTreeView';
// import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Button from 'react-bootstrap/Button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputMask } from 'primereact/inputmask';

import { getApiData, getServiceHubEnums, postApiData } from '../../../services/apiService';
import BrandFormModal from '../../modals/BrandFormModal';
import InvoiceListModal from '../../modals/InvoiceListModal';
import { serviceRequestData } from '../../../services/serviceHubStore';
import ProductUnitFormModal from './ProductUnitFormModal';
import ServiceRequestRequiredPartsModal from './ServiceRequestRequiredPartsModal';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { FaListCheck } from "react-icons/fa6";

export default function ServiceRequestAssessment (){
    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('Service Request Assessment');
    const [form_data, setFormData] = useState(serviceRequestData);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [sub_service_types, setSubTypes] = useState(store.order_enums);
    const [required_parts_modal, setRequiredPartsModal] = useState(0);
    const [product_unit_form_modal, setProductUnitFormModal] = useState(0);
    const [customer_modal, setContactModal] = useState(0);
    const [address_modal, setAddressModal] = useState(0);
    const [address_type, setAddressType] = useState('');
    const [same_address, setSameAddress] = useState(0);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [button_items, setButtonItems] = useState([]);
    const [show_brand_modal, setShowBrandModal] = useState(0);
    const dropdownRef = useRef(null);
    const [product_unit_id, setProductUnitID] = useState(0);
    const [target_product_unit, setTargetProductUnit] = useState({});
    const formRef = useRef(null);
    const [updated_required_parts, setUpdatedRequiredParts] = useState(0);
    
   
    useEffect(() => {
        initTreeView()

        if(service_request_id){
            setPageTitle('Service Request Assessment')
            fetchData(service_request_id)
        }
        else{
            setButtonItems([{
                label: 'Save and Confirm',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 2)
                }
            }])
            fetchEnums()
        }
    }, []);
   
    useEffect(() => {
        if(enums?.service_types){
            const sub_types = helpers.filterObject(enums.service_types, form_data.service_type_id)

            setSubTypes(sub_types?.sub_service_types)
        }
    }, [form_data.service_type_id]);

    
    useEffect(() => {
        if(updated_required_parts){
            submit()
        }
    }, [updated_required_parts])
    
    useEffect(() => {
        displayTableItems()
    }, [
        record_items,form_data
    ]);

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                    <tr>
                        <td>{data.qr_code}</td>
                        <td>{data.brand}</td>
                        <td>{data.serial_no}</td>
                        <td>{data.invoice_no ? data.invoice_no : '---'}</td>
                        <td>
                            <InputTextarea
                                name="assessment" 
                                value={data.assessment}  
                                className="w-100 mt-2 p-1"
                                maxLength={1000}
                                onChange={(e) => inputItemChange(e, key)}
                                placeholder="Unit Assessment"
                            />
                        </td>
                        <td>
                            <InputTextarea
                                name="recommendation" 
                                value={data.recommendation}  
                                className="w-100 mt-2 p-1"
                                maxLength={1000}
                                onChange={(e) => inputItemChange(e, key)}
                                placeholder="Unit Recommendation"
                            />
                        </td>
                        <td style={{paddingRight: '.75rem'}}>
                            <ButtonGroup aria-label="Basic example" size="sm">
                            </ButtonGroup>
                                <Button variant="info" onClick={() => requiredParts(data)} disabled={parseInt(form_data.status) !== 3 && parseInt(form_data.status) !== 4 && parseInt(form_data.status) !== 5}><FaListCheck /> Required&nbsp;Parts</Button>
                        </td>
                    </tr>
                )
            })
        }

        setTableItems(items)
    }
    
    function inputItemChange(e, key) {
        let { value, name } = e.target;
        let items = [...record_items]
        let target = {...items[key]}

        target[name] = value
        items[key] = target

        setRecordItems(items)
    }

    function requiredParts(e){
        let new_errors = {...errors}

        if(!form_data.assessment_date){
            new_errors['assessment_date'] = ['The assessment date field is required.']
        }
        else{
            delete new_errors['assessment_date'];
        }
       
        if(new_errors.assessment_date !== undefined){
            setErrors(new_errors);
            return
        }
        setProductUnitID(e.id)
        setTargetProductUnit(e)
        setRequiredPartsModal(1)
    }

    function removeItem(key){
        let items = [...record_items]
        items.splice(key, 1); 

        setRecordItems(items)
    }


    const fetchEnums = async () => {
        setLoading(true)
        const res = await getServiceHubEnums()
        if(res.status === 'success'){
            setEnums(res.data)
            setLoading(0)
        }
    }

    async function fetchData(id){
        setLoading(1)
        if(!id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            res.assessment_date = res.assessment_date ? new Date(res.assessment_date) : ''
            setFormData(res)
            fetchEnums()
            setRecordItems(res.items)
            setErrors([])
        }
        
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/service-requests/list");
                }
            })
        }
    }

    async function submit(status = ''){
        //e.preventDefault()

        form_data.items = record_items
        
        let new_form = {
            assessment_date: form_data.assessment_date,
            assessment: form_data.assessment,
            recommendation: form_data.recommendation,
            labor_fee: form_data.labor_fee,
            items: form_data.items ?? [],
        }
        
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}/assessment`)
        const res = await postApiData(endpoint, form_data)

        setLoading(0)
        if(res.status === 'error'){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            return
        }

        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
        })
        .then((result) => {
            fetchData(service_request_id)
        })
    }
    
    function inputChange(e) {
        let { name, value } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        //helpers.updateFormKeys(setFormData, new_state)
        setFormData({ ...form_data, ...new_state });
    }

    function handleRequiredParts(id, required_part_items){
        setRecordItems(prevItems => {
            const index = helpers.isObjectExistIndex(prevItems, id);

            if (index !== null) {
                const existing = prevItems[index];

                const updatedItem = {
                    ...existing,
                    required_parts: required_part_items
                };

                return helpers.updateItemInState(prevItems, updatedItem);
            }
        });

        setUpdatedRequiredParts(Math.random());
        // if (formRef.current) {
        //     formRef.current.submit(); // Calls the native DOM submit method
        // }
        
    }

    return (
        <div>

            <ServiceRequestRequiredPartsModal
                is_show={required_parts_modal}  
                setShow={setRequiredPartsModal} 
                handleSubmit={handleRequiredParts} 
                exclude={record_items}
                data = {target_product_unit}
                product_unit_id = {product_unit_id}
                service_request_id = {service_request_id}
            />

            <Layout page_title={page_title} menu="manage-service-requests" breadcrumbs={true} parent_link='/service-requests/list' parent_text="PolarCare">
                    <div className="content">
                        <div className="container-fluid pb-5" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <form ref={formRef} onSubmit={submit}>
                                <div className="row mb-2">
                                    <div id="so-customer-section" className="col-lg-12">
                                    
                                        {form_data.service_no ?
                                        <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                                            <h5 className='mb-3 mb-md-0 d-flex'>Service No: {form_data.service_no}
                                                &nbsp;&nbsp;&nbsp;{helpers.displayServiceRequestStatusBadge(form_data.status, form_data.status_name)}
                                            </h5>
                                            <div className='d-flex flex-column flex-sm-row'>
                                            </div>
    
                                            <div className='text-right'>     
                                                {
                                                    parseInt(form_data.status) === 3 || parseInt(form_data.status) === 4 || parseInt(form_data.status) === 5 ?
                                                    <button type='button' className='btn btn-success ml-3' onClick={() => submit()}>Publish</button> : ''
                                                }
                                                <Link className='btn btn-outline-dark ml-3' to={'/service-requests/list'}>Cancel</Link>
                                            </div>
                                        </div> : ''}

                                        <div className="card">
                                            <div className="card-body pt-md-5">
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Assessment Date<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <div>
                                                        <Calendar 
                                                            name="assessment_date"
                                                            placeholder="Assessment Date"
                                                            value={form_data.assessment_date} 
                                                            onChange={inputChange} 
                                                            className='w-100' 
                                                            dateFormat="yy-mm-dd" 
                                                            icon={() => <i className="far fa-calendar"></i>} 
                                                            showIcon  
                                                            
                                                        />
                                                        </div>
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="assessment_date" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>General Assessment <span className="text-danger"></span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputTextarea
                                                            name="assessment"
                                                            id="assessment" 
                                                            value={form_data.assessment}  
                                                            className="w-100 mt-2 p-1"
                                                            maxLength={1000}
                                                            onChange={inputChange}
                                                            placeholder="General Assessment"
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="assessment" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>General Recommendation <span className="text-danger"></span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputTextarea
                                                            name="recommendation"
                                                            id="recommendation" 
                                                            value={form_data.recommendation}  
                                                            className="w-100 mt-2 p-1"
                                                            maxLength={1000}
                                                            onChange={inputChange}
                                                            placeholder="General Recommendation"
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="recommendation" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Labor Fee <span className="text-danger"></span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputNumber 
                                                            name="labor_fee"
                                                            inputId="currency-ph" 
                                                            value={form_data.labor_fee} 
                                                            onValueChange={inputChange} 
                                                            mode="currency" 
                                                            currency="PHP" 
                                                            locale="en-US" 
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="recommendation" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                

                                <div invoice_id="so-item-container mt-5" className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body p-0 table-responsive">
                                                <table className='table mb-0'>
                                                    <thead className='thead-light'>
                                                        <tr>
                                                            <th>QR CODE</th>
                                                            <th>BRAND</th>
                                                            <th>SERIAL NO</th>
                                                            <th>INVOICE NO</th>
                                                            <th>ASSESSMENT</th>
                                                            <th>RECOMMENDATION</th>
                                                            <th>ACTION</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {table_items}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='text-right mt-3'>
                                    {
                                        parseInt(form_data.status) === 3 || parseInt(form_data.status) === 4 || parseInt(form_data.status) === 5 ?
                                        <button type='button' className='btn btn-success ml-3' onClick={() => submit()}>Publish</button> : ''
                                    }
                                    <Link className='btn btn-outline-dark ml-3' to={'/service-requests/list'}>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
            </Layout>
        </div>
    )
}